<template>
  <div class="pay-success flex-col">
    <!-- <div class="ptitle blod flex-row">
      <img class="success_img" src="./img/success.png" alt="" />
      <span>开店申请提交成功！</span>
    </div> -->
    <div class="zhu" style="padding: 0 20px 20px 20px; color: #ff142f;text-indent: 2rem;">
      注：承运商在中交物流平台注册开店，自愿购买物流专区增值服务，成为物流专区会员，享受专区增值服务：1.打破法人墙，不受“合作意向单位“限制，可以参与物流专区所有物流业务报名报价；2.通过专区门户“货找车”专栏对会员单位进行展现、推广、宣传；3.提供项目信息、精准推送，提供有价值的物流需求业务，系统智能匹配，形成撮合交易服务；4.提供中交集团在建项目信息、数据信息查询、竞争对手分析、供应链金融服务、全流程短信提醒、专属客户经理、行业数据分析等高附加值服务。5. 店铺服务费标准为: ￥3000.00元/年。
    </div>
    <div class="ptitle_row flex-row">
      <span class="blod">请您支付店铺年服务费</span>
      <a style="color: #0089ef; font-size: 14px" @click="goHomePage"
        >返回首页</a
      >
    </div>
    <div class="ptitle_box flex-row padding-20">
      <span
        >订单号：{{ orderCode }}
        <el-button class="copy-btn" @click="copyText(orderCode)"
          >复制</el-button
        ></span
      >
      <span
        >支付金额(元)：<span style="color: red">￥{{ cost }}</span></span
      >
    </div>
    <div class="ptitle_row flex-row">
      <span class="blod">请选择付款方式</span>
    </div>
    <div class="ptitle_row flex-row" style="justify-content: flex-start">
      <div
        v-if="getWLOptions.payTypeList.includes(2)"
        class="pay-way flex-row-start"
        :class="{ 'pay-way-selected': payWayType === 2 }"
        @click="payTypeChange(2)"
      >
        <img style="margin: 0 15px" src="./img/wx.png" alt="" />
        <div class="flex-col way-content" style="align-items: flex-start">
          <span class="font-style-normal">微信支付</span>
          <span class="font-style-normal-2">推荐使用，方便快捷</span>
        </div>
      </div>
      <div
        v-if="getWLOptions.payTypeList.includes(4)"
        class="pay-way flex-row-start"
        :class="{ 'pay-way-selected': payWayType === 4 }"
        @click="payTypeChange(4)"
      >
        <img style="margin: 0 15px" src="./img/zz.png" alt="" />
        <div class="flex-col way-content" style="align-items: flex-start">
          <span class="font-style-normal">公对公转账汇款</span>
          <span class="font-style-normal-2"
            >通过银行线下汇款的方式转账购买</span
          >
        </div>
      </div>
    </div>
    <template v-if="payWayType === 2">
      <div class="flex-col" v-if="isPaySuccess">
        <img
          src="./img/success.png"
          alt=""
          style="width: 79px; height: 79px; margin-top: 60px"
        />
        <!-- <span style="margin: 30px 0 228px 0; font-size: 24px; color: #4a4a4a"
          >支付成功</span
        > -->
        <span style="margin: 30px 0 228px 0; font-size: 24px; color: #4a4a4a"
          >提交成功</span
        >
      </div>
      <div class="qrcode flex-col" v-else>
        <div class="img-box" v-loading="!url">
          <img
            v-if="url"
            :src="url"
            alt=""
            style="width: 276px; height: 276px; object-fit: contain"
          />
        </div>
        <div style="font-size: 16px; padding: 20px">
          <span v-if="payTime > 0"
            >请在
            <span style="color: #ff0037">{{ payTime }}</span> 秒内扫码支付</span
          >
          <span style="color: #0089ef; cursor: pointer" @click="reloimg">
            刷新</span
          >
        </div>
      </div>
      <div style="color: #ff7a45; font-size: 14px; max-width: 740px">
        <!-- 提示：请在支付完成后点击提交，或点击试运行可试运行3个月，期间不收费。 -->
        提示：请在支付完成后点击提交，成为物流专区会员，可以参与专区全部物流业务，不受合作单位限制，并享受专区其他增值服务；试运行单位在试用期结束后，可参与原合作单位业务，如有意愿与其他单位合作，需再次申请合作意向。
      </div>
    </template>
    <template v-else>
      <div class="flex-col" v-if="isPaySuccess">
        <img
          src="./img/success.png"
          alt=""
          style="width: 79px; height: 79px; margin-top: 60px"
        />
        <span style="margin: 30px 0 228px 0; font-size: 24px; color: #4a4a4a"
          >提交成功</span
        >
      </div>
      <publicToPublic v-else ref="ptp" :orderCode="orderCode" />
    </template>
  </div>
</template>

<script>
import publicToPublic from "./publicToPublic.vue";

export default {
  components: { publicToPublic },
  inject: ["getWLOptions"],
  props: {
    orderCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: true,
      payTime: 90,
      url: "",
      isPaySuccess: false,
      timel: null,
      payWayType: 2, // weixin 2 gdg 4
    };
  },
  computed: {
    cost() {
      return this.getWLOptions.orderMoney;
    },
  },
  methods: {
    goHomePage() {
      this.$router.push("/index");
    },
    startDJS(val) {
      this.payTime == 90;
      clearInterval(this.timel);
      this.url = val.imageUrl;
      this.loading = false;
      this.timel = setInterval(() => {
        this.payTime--;
        if (this.payTime === 0) {
          clearInterval(this.timel);
        }
      }, 1000);
    },
    reloimg() {
      this.$emit("reloimg");
      //imageUrl:'http://cccc-test.obs.cn-north-4.myhuaweicloud.com/cccc_temp/temp38e793e8825d41d1aac05d6c71376cfd.png?AccessKeyId=VQWZQULFDTWJPDLZDNHH&Expires=1750145566&Signature=%2FVWxDI1Pdd5hZJvk7r3rEEZ2Yec%3D'}
    },
    paySuccess() {
      this.isPaySuccess = true;
    },
    payTypeChange(type) {
      if (this.isPaySuccess) return;
      this.payWayType = type;
      this.$emit("wuliuPayTypeChange", type);
      if (type == 4) {
        this.$nextTick(() => {
          this.$refs.ptp && this.$refs.ptp.setData();
        });
      }
    },
    async validateForm() {
      const res = await this.$refs.ptp.validateForm();
      return res;
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("复制成功！");
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-success /deep/.el-loading-spinner {
  margin-top: 0;
  margin-left: 0;
  transform: translate(-50%, -50%);
}
.pay-success {
  width: 100%;
}
.flex-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-row-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.ptitle {
  color: #4a4a4a;
  font-size: 20px;
  margin-bottom: 20px;
  .success_img {
    width: 40px;
    height: 40px;
    margin: 0 10px;
  }
}
.ptitle_row {
  width: calc(100% - 40px);
  margin: 0 20px 20px 20px;
  color: #4a4a4a;
  font-size: 20px;
  .success_img {
    width: 40px;
    height: 40px;
    margin: 0 10px;
  }
}
.qrcode {
  width: 100%;
  // border-top: 1px solid #f2f2f2;
  margin-top: 20px;
  padding: 20px 0;
  .img-box {
    width: 296px;
    height: 296px;
    border-radius: 8px;
    border: 1px solid #e9e9e9;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.blod {
  font-weight: 600;
}
.text-red {
  color: #ff142f;
}
.ptitle_box {
  width: calc(100% - 80px);
  margin: 0 20px 20px 20px;
  height: 70px;
  font-size: 16px;
  background: #f9fafb;
  border-radius: 8px;
}
.padding-20 {
  padding: 0 20px;
}
.pay-way {
  width: 400px;
  height: 70px;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
  margin-right: 40px;
  cursor: pointer;
  .way-content {
    font-family: PingFangSC, PingFang SC;
    color: #4a4a4a;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    margin: 0 15px;
    .font-style-normal {
      font-weight: 500;
      font-size: 16px;
    }
    .font-style-normal-2 {
      color: #999999;
      font-weight: 400;
      font-size: 14px;
    }
  }
}
.pay-way-selected {
  border: 1px solid #ff142f;
}
.copy-btn {
  padding: 0 7px;
  height: 25px;
  border-color: red;
  color: red;
}
</style>
